import { useMemo } from 'react';
import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';
import { PromotionCopilotRequest } from 'libs/end-to-end/src/custom-viz/PromotionCopilotTypes';

export const usePromotionCopilotCurrentCustomVizRequestToExecute = ({
  selectedDepartments,
  selectedRoles,
  selectedLocations,
  observation,
  organizationId,
}: {
  selectedDepartments: string[];
  selectedRoles: string[];
  selectedLocations: string[];
  observation: ObservationLocationType;
  organizationId: string;
}) => {
  return useMemo<PromotionCopilotRequest | null>(() => {
    return {
      customVizId: 'promotionCopilot',
      inputs: {
        dropdowns: {
          department: selectedDepartments,
          job_title: selectedRoles,
          location: selectedLocations,
        },
        extras: {
          modelContext: {
            organizationId,
            databaseId: observation.databaseId,
            databaseRevisionId: observation.databaseRevisionId,
          },
        },
      },
      observationLocationType: observation,
      organizationId,
    };
  }, [
    organizationId,
    selectedDepartments,
    selectedLocations,
    selectedRoles,
    observation,
  ]);
};
